import React from 'react';
import styles from './ImageShadowCaption.module.scss';

export const ImageShadowCaption = ({
    // Can be used to pass down border radius
    captionContainerClass = '',
    children,
}: {
    children: React.ReactElement;
    captionContainerClass?: string;
}) => {
    return (
        <>
            <figcaption
                className={`${styles.imageCaptionContainer} ${captionContainerClass}`}
            >
                <span className={styles.imageCaptionText}>{children}</span>
            </figcaption>
        </>
    );
};
